import { useMapStore } from '@/stores/useMapStore'

export function usePortfolioChartColors() {
  const lineColor = {
    water: '#0066b4',
    pv: '#ffcc2e',
    biogas: '#21a061',
    eeg: '#888',
  }

  const priceColor = '#1d8e85'

  const clpColor = '#ddd'

  function getPowerColor(cubeId) {
    const mapStore = useMapStore()
    const cube = mapStore.getCubeByName(cubeId, 'tour')
    return lineColor[cube.productionType]
  }

  return {
    priceColor,
    clpColor,
    getPowerColor,
  }
}
